var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateStrategyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_3086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.14454 10.306C1.78613 12.3911 2.0983 14.5362 3.03612 16.4327C3.97395 18.3292 5.48912 19.8794 7.36369 20.8603C9.23827 21.8412 11.3757 22.2023 13.4684 21.8916C15.5612 21.5809 17.5015 20.6145 19.0103 19.1313C20.5191 17.6482 21.5186 15.7247 21.865 13.6375C22.2115 11.5504 21.887 9.40713 20.9384 7.51604C19.9897 5.62495 18.4657 4.08347 16.5855 3.11332C14.7053 2.14316 12.5659 1.79433 10.4749 2.11699L10.8145 4.31755C12.4399 4.06673 14.103 4.33789 15.5645 5.09203C17.026 5.84617 18.2107 7.04442 18.9481 8.51444C19.6856 9.98446 19.9378 11.6505 19.6685 13.2729C19.3992 14.8953 18.6222 16.3905 17.4494 17.5435C16.8722 18.1109 16.2138 18.5809 15.5 18.9409C14.8705 19.2583 14.1979 19.4901 13.5 19.6273C13.3812 19.6507 13.2617 19.6713 13.1415 19.6891C12.5952 19.7702 12.045 19.7924 11.5 19.7573C10.8195 19.7134 10.1469 19.5802 9.5 19.3604C9.12209 19.2321 8.75293 19.0742 8.39602 18.8875C8.03317 18.6976 7.68765 18.4803 7.36207 18.2382C6.38011 17.5082 5.57951 16.5528 5.03203 15.4457C4.95427 15.2885 4.88205 15.129 4.8154 14.9677C4.55185 14.3297 4.37548 13.6618 4.28891 12.9821C4.19212 12.2222 4.20759 11.4475 4.33896 10.6832L2.14454 10.306Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.9999H15.5V18.9409C16.2138 18.5809 16.8722 18.1109 17.4494 17.5435L17.5 12.9999Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.9999H11.5V19.7573C12.045 19.7924 12.5952 19.7702 13.1415 19.6891C13.2617 19.6713 13.3812 19.6507 13.5 19.6273V14.9999Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2798 7.68656L14.5 8.5C12.3716 12.4821 7.389 12.7925 4.28891 12.9821C4.37548 13.6618 4.55185 14.3297 4.8154 14.9677C8.015 14.7978 13.8792 13.9679 16 10L17.5 11L16.5 6L13.2798 7.68656Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 2.00001H6.00001V4.00001H8.00001V6.00001H6.00001V8.00001H4.00001V6.00001H2.00001L2.00001 4.00001H4.00001V2.00001Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.9999H7.36207V18.2382C7.68765 18.4803 8.03317 18.6976 8.39602 18.8875C8.75293 19.0742 9.12209 19.2321 9.5 19.3604V16.9999Z",
    fill: "#2D64E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_3086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateStrategyIcon);
export default __webpack_public_path__ + "static/media/create-strategy-icon.bea8c48d66506d61cfe6666328999161.svg";
export { ForwardRef as ReactComponent };